// BASE_URL configuration
// Production API URL: https://smartagroai.lk/api
// Development API URL: http://localhost:8080/api

const getBaseUrl = () => {
  return 'https://ibas.lk/api'; // Production

  //return "http://localhost:8070/api"; // Local development
};

const BASE_URL = getBaseUrl();

const IMAGE_BASE_URL = BASE_URL; // ✅ DYNAMICS MATCHES ACTIVE BASE_URL

// Default placeholder images (served locally)
const DEFAULT_USER_PROFILE_IMAGE = `${IMAGE_BASE_URL}/uploads/user-images/avatar.png`;
const DEFAULT_COURSE_COVER_IMAGE = `${IMAGE_BASE_URL}/uploads/course-thumbnails/courceImg.jpeg`;

// Upload API endpoints
const UPLOAD_COURSE_THUMBNAIL_URL = `${BASE_URL}/upload/course-thumbnail`;
const UPLOAD_USER_IMAGE_URL = `${BASE_URL}/upload/user-image`;
const UPLOAD_BADGE_IMAGE_URL = `${BASE_URL}/upload/badge-image`;
const UPLOAD_CERTIFICATE_FILE_URL = `${BASE_URL}/upload/certificate-file`;
const UPLOAD_PAYMENT_SLIP_URL = `${BASE_URL}/upload/payment-slip`;
const UPLOAD_ASSESSMENT_DOCUMENT_URL = `${BASE_URL}/upload/assessment-document`;
const UPLOAD_STUDENT_DOCUMENT_URL = `${BASE_URL}/upload/student-verification-document`;

export {
  BASE_URL,
  IMAGE_BASE_URL,
  DEFAULT_USER_PROFILE_IMAGE,
  DEFAULT_COURSE_COVER_IMAGE,
  UPLOAD_COURSE_THUMBNAIL_URL,
  UPLOAD_USER_IMAGE_URL,
  UPLOAD_BADGE_IMAGE_URL,
  UPLOAD_CERTIFICATE_FILE_URL,
  UPLOAD_PAYMENT_SLIP_URL,
  UPLOAD_ASSESSMENT_DOCUMENT_URL,
  UPLOAD_STUDENT_DOCUMENT_URL,
};
